/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     企业信息 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";

export function getEnterpriseDetailApi(params) {
  return request({
    url: "?c=sys&a=enterprise&do=get",
    method: "get",
    params
  });
}

export function editEnterpriseApi(formData) {
  return request({
    url: "?c=sys&a=enterprise&do=post",
    method: "post",
    data: formData
  });
}

export function changegManagerApi(formData) {
  return request({
    url: "?c=sys&a=enterprise&do=switch",
    method: "post",
    data: formData
  });
}

export function getSettingApi(params) {
  return request({
    url: "?c=sys&a=setting&do=get",
    method: "get",
    params
  });
}

export function postSettingApi(formData) {
  return request({
    url: "?c=sys&a=setting&do=post",
    method: "post",
    data: formData
  });
}
